import React from "react";

const ProyectoIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13 21.325v-7l-5-5-5 5v7h5m5 0H8m5 0h8v-17a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v6m-1 11v-4m5-10v.01m4-.01v.01m0 3.99v.01m0 3.99v.01"
    ></path>
  </svg>
);

export default ProyectoIcon;
